import {
  index,
  integer,
  jsonb,
  pgTable,
  serial,
  text,
  uuid,
} from "drizzle-orm/pg-core";
import { createSchemaFactory } from "drizzle-zod";
import { z } from "zod";

import type { BracketTemplateConfig } from "@/lib/bracket-template";

import { timestamps } from "./shared";
import { venues } from "./venues";

const { createInsertSchema, createSelectSchema, createUpdateSchema } =
  createSchemaFactory({ zodInstance: z });

export const playoffBracketTemplates = pgTable(
  "playoff_bracket_templates",
  {
    id: serial().primaryKey(),
    venueId: integer()
      .notNull()
      .references(() => venues.id, { onDelete: "cascade" }),
    name: text().notNull(),
    description: text(),
    config: jsonb().$type<BracketTemplateConfig>().notNull(),
    externalRef: uuid().unique(),
    ...timestamps,
  },
  (table) => [
    index("playoff_bracket_templates_venue_id_idx").on(table.venueId),
  ],
);

export const selectPlayoffBracketTemplateSchema = createSelectSchema(
  playoffBracketTemplates,
);
export const createPlayoffBracketTemplateSchema = createInsertSchema(
  playoffBracketTemplates,
).omit({
  id: true,
  createdAt: true,
  updatedAt: true,
});
export const updatePlayoffBracketTemplateSchema = createUpdateSchema(
  playoffBracketTemplates,
);

export type PlayoffBracketTemplate = z.infer<
  typeof selectPlayoffBracketTemplateSchema
>;
export type CreatePlayoffBracketTemplate = z.infer<
  typeof createPlayoffBracketTemplateSchema
>;
export type UpdatePlayoffBracketTemplate = z.infer<
  typeof updatePlayoffBracketTemplateSchema
>;
